import { Box, Typography, Divider } from '@mui/material';
import { IoCameraOutline, IoImagesOutline, IoChevronForward } from 'react-icons/io5';
import BottomSheet from '@/Components/MagicLink/BottomSheet';

export type SelectUploadOptionBottomSheetProps = {
    open: boolean;
    onClose: () => void;
    headline?: string;
    onTakePhoto: () => void;
    onSelectFromGallery: () => void;
};

const SelectUploadOptionBottomSheet = ({
    open,
    onClose,
    headline = 'Predná strana občianskeho preukazu',
    onTakePhoto,
    onSelectFromGallery,
}: SelectUploadOptionBottomSheetProps) => {
    return (
        <BottomSheet open={open} onClose={onClose}>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                <Typography variant="h6" component="h2">
                    {headline}
                </Typography>

                <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                    {/* Option 1: Take Photo */}
                    <Box
                        onClick={() => {
                            onTakePhoto();
                            onClose();
                        }}
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 2,
                            paddingY: 2,
                            cursor: 'pointer',
                        }}
                    >
                        <IoCameraOutline size={24} />
                        <Typography variant="body1" sx={{ flex: 1 }}>
                            Odfotiť OP
                        </Typography>
                        <IoChevronForward size={24} />
                    </Box>

                    <Divider />

                    {/* Option 2: Select from Gallery */}
                    <Box
                        onClick={() => {
                            onSelectFromGallery();
                            onClose();
                        }}
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 2,
                            paddingY: 2,
                            cursor: 'pointer',
                        }}
                    >
                        <IoImagesOutline size={24} />
                        <Typography variant="body1" sx={{ flex: 1 }}>
                            Vybrať z galérie
                        </Typography>
                        <IoChevronForward size={24} />
                    </Box>
                </Box>
            </Box>
        </BottomSheet>
    );
};

export default SelectUploadOptionBottomSheet;

